import { render, staticRenderFns } from "./QRCodeDownload.vue?vue&type=template&id=42bd0f94&scoped=true&"
import script from "./QRCodeDownload.vue?vue&type=script&lang=js&"
export * from "./QRCodeDownload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42bd0f94",
  null
  
)

export default component.exports